export default __webpack_public_path__ + "static/media/banner1_web_fallback.db8a70b5.jpg";